import { render, staticRenderFns } from "./ReportFormFollowUp.vue?vue&type=template&id=f55e9796&scoped=true&"
import script from "./ReportFormFollowUp.vue?vue&type=script&lang=js&"
export * from "./ReportFormFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormFollowUp.vue?vue&type=style&index=0&id=f55e9796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55e9796",
  null
  
)

export default component.exports